import React, { useContext, useRef, useState } from "react";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr"
import { useEffect } from "react";
import { useAuth } from "./AuthContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCallback } from "react";
import useFetchSimple from "./useFetchSimple";
import { endpoints } from "../utils/Constants";
import { useLocalStorage } from "../utils/Hooks/useLocalStorage";

const SignalRContext = React.createContext(false);
const useSignalR = () => {

    return useContext(SignalRContext);
}

// create and export the AuthProvider - this is imported to the _app.js file
// and wrapped around the whole app, providing context to the whole app, and
// is called each time this specific context is accessed (updated or retrieved)
const SignalRProvider = ({ children }) => {
    const [currentUser,] = useLocalStorage("user");
    const [state, setState] = useState({});
    const { hubMessage, hubError, hubJwt } = state ? state : {};
    const [auth] = useAuth();
    const { jwt } = auth;
    const starting = useRef(false);

    const fetch = useFetchSimple();

    const setHubMessage = useCallback((message) => {
        setState({ hubMessage: message, hubError, hubJwt });

    }, [hubError, hubJwt]);
    const connection = useRef();

    const startHub = async () => {
        if (!connection.current) {

            try {
                const getToken = () => {
                    const token = currentUser && currentUser.accessToken ? currentUser.accessToken.token : null;
                    return token;
                }
                const options = {
                    accessTokenFactory: getToken,
                    transport: 2,
                };
                await fetch(endpoints.test);
                connection.current = new HubConnectionBuilder()
                    .withUrl("/entityHub", options)
                    .configureLogging(LogLevel.Information)
                    .build();

                connection.current.on("EntityUpdate", (message) => {

                    setHubMessage(message);
                }, (error) => {
                    setState({ hubMessage: null, hubError: error, hubJwt: null });
                });

                connection.current.on("SendNotification", (message) => {

                    toast(<React.Fragment><h5>{message.title}</h5>
                        <p>{message.body}</p></React.Fragment>);
                });
                connection.current.onclose(async (r) => {
                    starting.current = false;

                });

                setState({ hubMessage: null, hubError: null, hubJwt: null });
            } catch (err) {
                connection.current && connection.current.stop();
                starting.current = false;
                connection.current = null;
                setState({ hubMessage: null, hubError: err ? err : 'Exception', hubJwt: hubJwt });
            }
        };
    };
    startHub();


    const start = useCallback(() => {

        const myStart = async () => {
            try {
                if (jwt && connection.current && !hubError && !starting.current) {
                    starting.current = true;
                    await connection.current.start();
                    setState({ hubMessage, hubError, hubJwt: jwt });
                }
                if (!jwt && connection.current) {
                    // logged out!
                    starting.current = false;
                    connection.current.stop();
                    setState({ hubMessage: null, hubError: null, hubJwt: jwt });
                }

            } catch (err) {
                connection.current && connection.current.stop();
                starting.current = false;

                setState({ hubMessage: null, hubError: err, hubJwt: jwt });
            }

        }

        myStart();
    }, [jwt, hubError, hubMessage]);

    useEffect(() => {
        if ((hubError || !starting.current) && connection.current) {

            if (jwt !== hubJwt) {
                setState({ hubMessage: null, hubError: null, hubJwt: jwt });

                start();
            }

        }
    }, [jwt, hubError, start, hubJwt]);

    return (

        <SignalRContext.Provider value={{ hubMessage, hubError, setHubMessage }}>
            <ToastContainer />
            {children}
        </SignalRContext.Provider>

    )
};

export { SignalRProvider, useSignalR };